// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".number-input[data-v-1ade7176]::-webkit-inner-spin-button,.number-input[data-v-1ade7176]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}.number-input-wrap[data-v-1ade7176]{width:100%}.number-input[type=number][data-v-1ade7176]{-moz-appearance:textfield}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
